
import ImageUploader from '@/components/common/ImageUploader.vue'

// 规格类型单一真理源：表格"标签类型"列翻译与新增/编辑下拉同源（分叉即 bug）。
// 覆盖库内全部 tag_type（含 2031 导入产生的 spec_vehicle_model/spec_tool_size/spec_batt_model/
// spec_ply/spec_tire_type/spec_bulb_*，此前缺失导致列显示英文 + 编辑下拉匹配不到显示空白）。
const SPEC_TYPE_GROUPS = [
  { label: '车型', types: [['spec_vehicle_model', '适配车型']] },
  { label: '轮胎', types: [['spec_width', '轮胎宽度'], ['spec_size', '轮胎尺寸'], ['spec_ply', '轮胎层级'], ['spec_tire_type', '轮胎类型']] },
  { label: '电瓶', types: [['spec_voltage', '电瓶电压'], ['spec_batt_type', '电瓶类型'], ['spec_batt_model', '电瓶型号']] },
  { label: '机油', types: [['spec_grade', '机油粘度']] },
  { label: '工具', types: [['spec_tool_size', '工具尺寸']] },
  { label: '轴承', types: [['spec_bearing_model', '轴承型号'], ['spec_bearing_id', '轴承内径'], ['spec_bearing_od', '轴承外径'], ['spec_bearing_width', '轴承宽度'], ['spec_bearing_type', '轴承类型']] },
  { label: '油封', types: [['spec_seal_id', '油封内径'], ['spec_seal_od', '油封外径'], ['spec_seal_thickness', '油封厚度'], ['spec_seal_material', '油封材质']] },
  { label: '链条', types: [['spec_chain_pitch', '链条节距'], ['spec_chain_links', '链条节数']] },
  { label: '链轮', types: [['spec_sprocket_teeth', '链轮齿数'], ['spec_sprocket_pitch', '链轮节距']] },
  { label: '火花塞', types: [['spec_spark_thread', '火花塞螺纹规格'], ['spec_spark_heat', '火花塞热值'], ['spec_spark_length', '火花塞螺纹长度']] },
  { label: '皮带', types: [['spec_belt_model', '皮带型号'], ['spec_belt_length', '皮带长度'], ['spec_belt_width', '皮带宽度']] },
  { label: '刹车片', types: [['spec_brake_model', '刹车片型号'], ['spec_brake_material', '刹车片材质']] },
  { label: '灯泡', types: [['spec_bulb_voltage', '灯泡电压'], ['spec_bulb_power', '灯泡功率']] }
]

export default {
  name: 'ProductTagsManage',
  components: { ImageUploader },
  data() {
    return {
      currentTab: 'model',
      tabs: [
        { key: 'model', label: '适用车型' },
        { key: 'category', label: '车型分类' },
        { key: 'spec', label: '规格参数' }
      ],
      tags: [],
      categories: [],
      showDialog: false,
      isEdit: false,
      form: this.getEmptyForm(),
      showCategoryDialog: false,
      isCategoryEdit: false,
      categoryForm: { name: '', sort_order: 0, icon: '' }
    }
  },
  computed: {
    specTypeGroups() {
      return SPEC_TYPE_GROUPS
    },
    tagTypeLabelMap() {
      const map = {}
      SPEC_TYPE_GROUPS.forEach(g => g.types.forEach(([val, text]) => { map[val] = text }))
      return map
    },
    filteredTags() {
      if (this.currentTab === 'spec') {
        return this.tags.filter(t => t.tag_type.startsWith('spec_'))
      }
      return this.tags.filter(t => t.tag_type === this.currentTab)
    }
  },
  mounted() {
    this.fetchTags()
    this.fetchCategories()
  },
  methods: {
    getEmptyForm() {
      return {
        tag_type: 'model',
        tag_key: '',
        tag_value: '',
        tag_label: '',
        sort_order: 0,
        is_active: 1,
        image: '',
        aliases: '',
        category_id: null
      }
    },
    async fetchTags() {
      try {
        const res = await this.axios.get('/admin/product-tags')
        if (res.data.code === 200) {
          this.tags = res.data.data || []
        }
      } catch (err) {
        console.error('获取标签失败:', err)
      }
    },
    async fetchCategories() {
      try {
        const res = await this.axios.get('/admin/vehicle-categories')
        if (res.data.code === 200) {
          this.categories = res.data.data || []
        }
      } catch (err) {
        console.error('获取分类失败:', err)
      }
    },
    openAdd() {
      this.form = this.getEmptyForm()
      this.form.tag_type = this.currentTab === 'spec' ? 'spec_width' : 'model'
      this.isEdit = false
      this.showDialog = true
    },
    editTag(tag) {
      this.form = { ...this.getEmptyForm(), ...tag }
      this.isEdit = true
      this.showDialog = true
    },
    closeDialog() {
      this.showDialog = false
      this.form = this.getEmptyForm()
    },
    async saveTag() {
      if (!this.form.tag_key || !this.form.tag_value) {
        alert('键值和显示值不能为空')
        return
      }
      try {
        if (this.isEdit) {
          await this.axios.put(`/admin/product-tags/${this.form.id}`, this.form)
        } else {
          await this.axios.post('/admin/product-tags', this.form)
        }
        this.closeDialog()
        this.fetchTags()
      } catch (err) {
        alert(err.response?.data?.message || '保存失败')
      }
    },
    async deleteTag(id) {
      if (!confirm('确定删除此标签？')) return
      try {
        await this.axios.delete(`/admin/product-tags/${id}`)
        this.fetchTags()
      } catch (err) {
        alert(err.response?.data?.message || '删除失败')
      }
    },
    onImageChange(url) {
      this.form.image = url || ''
    },
    getCategoryName(categoryId) {
      const cat = this.categories.find(c => c.id === categoryId)
      return cat ? cat.name : '-'
    },
    // ===== 车型分类 CRUD =====
    openCategoryAdd() {
      this.categoryForm = { name: '', sort_order: 0, icon: '' }
      this.isCategoryEdit = false
      this.showCategoryDialog = true
    },
    editCategory(cat) {
      this.categoryForm = { ...cat }
      this.isCategoryEdit = true
      this.showCategoryDialog = true
    },
    closeCategoryDialog() {
      this.showCategoryDialog = false
    },
    async saveCategory() {
      if (!this.categoryForm.name) { alert('分类名称不能为空'); return }
      try {
        if (this.isCategoryEdit) {
          await this.axios.put(`/admin/vehicle-categories/${this.categoryForm.id}`, this.categoryForm)
        } else {
          await this.axios.post('/admin/vehicle-categories', this.categoryForm)
        }
        this.closeCategoryDialog()
        this.fetchCategories()
      } catch (err) {
        alert(err.response?.data?.message || '保存失败')
      }
    },
    async deleteCategory(id) {
      if (!confirm('确定删除此分类？')) return
      try {
        await this.axios.delete(`/admin/vehicle-categories/${id}`)
        this.fetchCategories()
      } catch (err) {
        alert(err.response?.data?.message || '删除失败')
      }
    },
    onCategoryIconChange(url) {
      this.categoryForm.icon = url || ''
    }
  }
}
